export { default as purchaseSurvey } from './purchaseSurvey.yaml';
export { default as refinanceSurvey } from './refinanceSurvey.yaml';
export { default as loanOfficersRefinanceSurvey } from './loanOfficersRefinanceSurvey.yaml';
export { default as loanOfficersPurchaseSurvey } from './loanOfficersPurchaseSurvey.yaml';
export { default as quiz } from './quiz.yaml';



// WEBPACK FOOTER //
// ./src/lib/surveys/index.js